// OrderViewRoutes
export default [{
  name: 'Overview',
  path: '/overview/:type/:id',
  props: true,
  component: () => import(/* webpackChunkName: "page-overview" */ './Overview.vue'),
  meta: {
    requiresAuth: true,
  }
}];
